import * as React from "react";
import Grid from "@material-ui/core/Grid/Grid";
import Btn from "../Btn/Btn";
import {withI18n, WithI18n} from "../../core/i18n/withI18n";
import {compose} from "redux";
import {Theme, WithStyles} from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (t: Theme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  confirmButton: {
    marginLeft: t.spacing.unit
  }
});

interface IProps extends
  WithI18n,
  WithStyles<typeof styles>{
  cancelHandler?: () => void;
  cancelText?: string;
  confirmHandler: () => void;
  confirmText?: string;
  disableConfirm?: boolean;
  loading?:boolean
}

class FormActions extends React.Component<IProps>{
  render(){
    const {
      cancelHandler, cancelText, t, disableConfirm, confirmHandler, confirmText, classes, loading
    } = this.props;
    return (
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.root}>
            {cancelHandler &&
              <Btn
                onClick={cancelHandler}
                color='primary'
                disabled={loading}
              >{cancelText ? cancelText : t.cancel} </Btn>
            }

            <Btn
              disabled={disableConfirm}
              onClick={confirmHandler}
              variant='contained'
              color='primary'
              className={classes.confirmButton}
              loading={loading}
            >
              {confirmText ? confirmText : t.save}
            </Btn>
          </div>
        </Grid>
      </Grid>
    )
  }
}

export default compose(
  withI18n,
  withStyles(styles)
)(FormActions)



// WEBPACK FOOTER //
// ./src/shared/form/FormActions.tsx